<template>
  <div>
    <iframe :src="`https://${$route.query.u}`" />
  </div>
</template>
<script>
  export default {
    name: 'ViewTest',
    mounted () {
      let pixel = document.createElement('script')
      pixel.setAttribute('src', 'https://cdn-staging.useproof.com/proof.js?acc=FaqmdDysP5MwCwmVmJ6DewyAKtm2')
      document.body.appendChild(pixel)
    }
  }
</script>

<style>
  body {
    margin: 0;
  }
  iframe {
    border: none;
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/PixelTest/ViewTest.vue